import { SPSELECTS } from "InterfacesTypes/enums";
import type { ITitleText } from "InterfacesTypes/interfaces";
import { call, put, takeLatest } from "redux-saga/effects";
import { fetchFailure, fetchStart, fetchSuccess, fetchTitleTexts } from "state/reducers/TitleTextReducer";
import { spGet } from "utils/SharepointAPI";
import { getEnvironment } from "utils/utils";


const env = getEnvironment();
function* fetchTitleTextsWorker() {
  try {
    yield put(fetchStart());
    const titleTextsUrl = `${env.listapi}/GetByTitle('StartpageTitles')/Items?$top=5000&$select=${SPSELECTS.TITLETEXTS}`;
    const data: ITitleText[] = yield call(spGet, titleTextsUrl);
    yield put(fetchSuccess(data));
  } catch (err: any) {
    yield put(fetchFailure(err?.message ?? "Något gick fel"));
  }
}

export function* titleTextsSaga() {
  yield takeLatest(fetchTitleTexts.type, fetchTitleTextsWorker);
}
